import { Button, Stack } from '@mui/material'
import React from 'react'

const FormButtons = ({onSubmit,onCancel}) => {
  return (
    <Stack sx={{ marginTop:'20px'}} direction="row" justifyContent="flex-end" alignItems="center" spacing={2}>
        <Button color="primary" onClick={onSubmit}  variant="contained">Submit</Button>
        <Button color="error" onClick={onCancel} variant="contained">Cancel</Button>
    </Stack>
  )
}

export default FormButtons